import './Modal.scss';

import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

const Modal = ({ visible, onClose, className, width, title, closeable, children }) => {
	const [isVisible, setIsVisible] = useState(visible);

	const handleCloseClick = () => {
		setIsVisible(false);
		onClose();
	};

	useEffect(() => {
		setIsVisible(visible);
	}, [visible]);

	return (
		isVisible && (
			<FlexBox key={visible} alignItems='center' className={cx('react__modal', className)} justifyContent='center'>
				<div className='modal-box' style={{ width }}>
					<FlexBox alignItems='center' className='header' justifyContent='space-between'>
						<div className='title'>{title}</div>
						{closeable && (
							<FlexBox alignItems='center' className='close' justifyContent='flex-end' onClick={handleCloseClick} />
						)}
					</FlexBox>
					<div className='modal-cont'>{children}</div>
				</div>
			</FlexBox>
		)
	);
};

Modal.propTypes = {
	visible: PropTypes.bool,
	onClose: PropTypes.func,
	className: PropTypes.string,
	width: PropTypes.string,
	title: PropTypes.string,
	closeable: PropTypes.bool,
	children: PropTypes.node.isRequired
};

Modal.defaultProps = {
	visible: false,
	onClose: () => {},
	className: '',
	width: '360px',
	title: '',
	closeable: true
};

export default Modal;
